<template>
  <div class="nuttrema-layout-content-header" :class="[`theme-${theme}`]">
    <nav class="header-nav">
      <slot>
        <div class="header-nav--left" :class="[leftClassName]">
          <slot name="left"></slot>
        </div>
        <div class="header-nav--center" :class="[centerClassName]">
          <slot name="center"></slot>
        </div>
        <div class="header-nav--right" :class="[rightClassName]">
          <slot name="right"></slot>
        </div>
      </slot>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-layout-content-header',
  props: {
    leftClassName: {
      type: String,
      required: false,
      default: null,
    },
    centerClassName: {
      type: String,
      required: false,
      default: null,
    },
    rightClassName: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .nuttrema-layout-content-header {
    display: flex;
    height: 4.25em;
    min-height: 4.25em;
    position: relative;
    align-self: stretch;
    padding: 0.75em;
    flex-direction: column;
    border-bottom: 2px solid #DBE2EF;

    .header-nav {
      flex-grow: 1;
      display: flex;
      align-self: stretch;
      align-items: center;
      justify-content: space-between;

      .header-nav--left {
        flex-grow: 1;
        display: flex;
        // flex-shrink: 0;
        align-self: stretch;
        align-items: center;
      }
      .header-nav--center {
        flex-grow: 2;
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
      }
      .header-nav--right {
        flex-grow: 1;
        // flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .header-nav--left, .header-nav--right {
        min-width: 10em;
        max-width: 25em;
      }

      .content-header-item {
        display: flex;
        flex-shrink: 0;
        margin-right: 1em;
        > * {
          margin-right: 0.5em;
          &:last-child {
            margin-right: 0;
          }
        }

        > .el-switch {
          line-height: 19px;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &.theme-sub-header {
      background-color: rgba(#DBE2EF, 0.25);
    }

    &.theme-registration-steps {
      padding: 0;
      background-color: rgba(#DBE2EF, 0.25);
      /deep/ .el-steps {
        &.el-steps--simple {
          flex-grow: 1;
          padding-left: 1.25em;
          padding-right: 1.25em;
          .el-step__main {
            .el-step__title {
              font-size: 1em;
            }
          }
        }
      }
    }

    &.theme-mobile-header {
      flex-grow: 1;
      height: inherit;
      min-height: inherit;
      .header-nav {
        .header-nav--left, .header-nav--right {
          min-width: 3em;
        }
        .header-nav--center {
          > * {
            font-weight: 500;
          }
        }
      }
    }

    &.is-height-inherit {
      height: inherit;
    }

    &.is-slim {
      height: inherit;
      min-height: 3em;
      padding: 0.5em 0.75em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-content-header.vue